import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "../../src/redux/slices/HomeSlice";
import aboutReducer from "../../src/redux/slices/AboutSlice";
import serviceReducer from "../../src/redux/slices/ServicesSlice";
import ContactSlice from "../../src/redux/slices/ContactSlice";

const store = configureStore({
  reducer: {
    home: homeReducer,
    about: aboutReducer,
    services: serviceReducer,
    Contact: ContactSlice,
  },
});

export default store;
